import { ErrorModel } from "./errorModel";

export class RutaModel {

    codigoClienteDistribuidor: string;
    codigoClienteFabril: string;
    diaVisita: string;
    frecuenciaVisita: string;
    secuenciaVisita: string;
    semanaVisita: string;
    correct: boolean;
    error?: ErrorModel;
    
    constructor() { }

    devolverModeloGridRuta() {
        const objeto: RutaModelInterface = {
            codigoClienteDistribuidor: 'codigoClienteDistribuidor',
            codigoClienteFabril: 'codigoClienteFabril',
            diaVisita: 'diaVisita',
            frecuenciaVisita: 'frecuenciaVisita',
            secuenciaVisita: 'secuenciaVisita',
            semanaVisita: 'semanaVisita',
            correct: 'correct'
        };
        return objeto;
    }
}

export interface RutaModelInterface {
    codigoClienteDistribuidor: string;
    codigoClienteFabril: string;
    diaVisita: string;
    frecuenciaVisita: string;
    secuenciaVisita: string;
    semanaVisita: string;
    correct: string;
}